module.exports = __webpack_public_path__ + "static/media/040-La Cage.d39481a4.png";